import {
    GETMANUALSETTLEMENT_SUCCESS,
    GETMANUALSETTLEMENT_FAILED,
    RESET_GETMANUALSETTLEMENT,
    LOADING_GETMANUALSETTLEMENT,
    NETWORK_ERROR_GETMANUALSETTLEMENT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETMANUALSETTLEMENT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETMANUALSETTLEMENT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETMANUALSETTLEMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETMANUALSETTLEMENT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETMANUALSETTLEMENT:
            return (state = initialState);
        default:
            return state;
    }
};
